import { render } from "./News4.vue?vue&type=template&id=56d2ffed"
import script from "./News4.vue?vue&type=script&lang=js"
export * from "./News4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__